export function httpStatusOkOrPending(http_status_code){
  return (http_status_code >= 200 && http_status_code < 300) || [-1, 304].includes(http_status_code)
}
export function httpStatusOk(http_status_code){
  return (http_status_code >= 200 && http_status_code < 300) || [304].includes(http_status_code)
}